import SignIn from "./SignIn";

export default SignIn;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/authentication/SignIn/index.tsx